export const SIGNALR_MESSAGE_TYPES = {
  NOTIFICATION: "Notification",

  CORE_SECURITY_AUDITLOGS: "CORE_SECURITY_AUDITLOGS",
  CORE_LOGIN: "CORE_LOGIN",
};
